module.exports = __webpack_public_path__ + "static/keep-drilling-9290433118ffdd764b17ed8b86b9b0d9.jpg";